import dayjs from "apps/visits/packages/shared/libs/dayjs";
import { useEffect } from "react";
import { LS_EXPIRE_HOURS } from "../config/ls-expire-time";
import { useOrderingStore } from "../store/use-ordering-store";

export const useExpireLSState = (expireTime?: string) => {
  const { reset } = useOrderingStore();

  useEffect(() => {
    if (!expireTime) return;

    const now = dayjs();
    const expireTimeDate = dayjs(expireTime);
    const diffHours = now.diff(expireTimeDate, "hour");

    if (diffHours >= LS_EXPIRE_HOURS) reset();
  }, [expireTime, reset]);
};
